<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="isReplace ? '变更' : esop.pkId ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="esop"
        :rules="ruleValidate"
        class="form"
        label-width="90px">
      <el-form-item v-if="esop.pkId" label="文件编号">
        <el-input v-model="esop.esopNo" disabled/>
      </el-form-item>
      <el-form-item label="文档属性" prop="fileType">
        <el-select v-model="esop.fileType" placeholder="请选择">
          <el-option label="受控" :value="10"/>
          <el-option label="试行" :value="20"/>
          <el-option label="样品" :value="30"/>
        </el-select>
      </el-form-item>
      <el-form-item label="文件类别" prop="fileCategory">
        <el-select v-model="esop.fileCategory" placeholder="请选择" :disabled="esop.pkId>0">
          <!--          <el-option label="操作卡" :value="10"/>-->
          <el-option label="管理制度" :value="20"/>
          <el-option label="产品图纸" :value="30"/>
          <el-option label="承认书" :value="40"/>
          <el-option label="产品方案" :value="50"/>
          <el-option label="零部件图纸" :value="60"/>
          <el-option label="零部件展开图" :value="70"/>
          <el-option label="程序文件" :value="80"/>
          <el-option label="工艺文件" :value="90"/>
          <el-option label="供应商规格书" :value="100"/>
        </el-select>
      </el-form-item>
      <el-form-item label="上传文件" prop="filePath">
        <up-load-file
            ref="upload"
            :file="fileList"
            :auth-index="authIndex"
            @upload-success="uploadSuccess"
            @removeFile="removeFile"/>
      </el-form-item>
      <el-form-item label="文件名称" prop="esopName">
        <el-input v-model.trim="esop.esopName" placeholder="请输入文件名称"/>
      </el-form-item>
      <el-form-item label="物料名称" prop="materialId">
        <el-input v-model.trim="esop.materialName" disabled placeholder="请选择物料">
          <template v-if="flag" slot="append">
            <el-button icon="el-icon-search" @click="$refs.materialSelect.open()"/>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="物料编号">
        <el-input v-model.trim="esop.materialNo" disabled/>
      </el-form-item>
      <material-select ref="materialSelect" @select="addMaterial"/>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UpLoadFile from "@/components/UploadFile.vue";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";

  export default {
    components: {
      UpLoadFile,
      MaterialSelect,
    },

    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        authIndex: this.$route.meta.authIndex,
        fileList: [],
        esop: {
          pkId: 0,
          esopNo: "",
          fileType: 10,
          fileCategory: 20,
          esopName: "",
          filePath: "",
          materialName: "",
          materialNo: "",
          materialId: "",
          detailVos: [],
        },
        flag: false,
        isReplace: false,
        ruleValidate: {
          filePath: {required: true, message: "请上传文件", trigger: "change"},
          category: {required: true, message: "请选择文件类型", trigger: "change"},
          esopName: {required: true, message: "请输入文件名称", trigger: "blur"},
          materialId: {required: true, message: "请选择物料", trigger: "change"},
        },
      };
    },
    methods: {
      open(row, mark) {
        this.dialogVisible = true;
        this.flag = true;
        this.$nextTick(() => {
          if (row) {
            this.getData(row.pkId);
            this.flag = false;
          }
          if (mark === "replaceHandle") {
            this.isReplace = true;
          }
        });
      },

      //选择物料
      addMaterial(row) {
        this.esop.materialName = row.materialName;
        this.esop.materialId = row.materialID;
        this.esop.materialNo = row.materialNO;
      },

      // 文件上传成功
      uploadSuccess(file) {
        this.esop.filePath = file[0].key;
        this.esop.esopName = file[0].name;
        this.fileList = file;
      },

      removeFile(fileList) {
        this.fileList = fileList;
      },

      // 获取文件信息
      getData(pkId) {
        this.contentLoading = true;
        this.$http
            .get("basic", `esops/${pkId}`)
            .then((resp) => {
              if (resp.success) {
                console.log(resp);
                this.esop = Object.assign(this.esop, resp.data);
                if (!this.isReplace) {
                  this.fileList = [{name: resp.data.esopName, key: resp.data.filePath}];
                }
              }
              this.contentLoading = false;
            })
            .catch(() => {
              this.contentLoading = false;
            });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.fileList.length === 0) {
              this.$confirm("请上传文件", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            if (this.esop.pkId) {
              this.$http.post("basic", "esops/file/update", this.esop).then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.dialogVisible = false;
              }).catch(() => {
                this.submitLoading = false;
              });
            } else {
              this.$http.post("basic", "esops/file/insert", this.esop).then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                  this.dialogVisible = false;
                }
              }).catch(() => {
                this.submitLoading = false;
              });

              // const params = {
              //   pkid: this.esop.pkId,
              //   esopName: this.esop.esopName,
              //   filePath: this.esop.filePath,
              // };
              // this.$http
              //     .post("basic", "esops/replaceEsop", params)
              //     .then((res) => {
              //       if (res.success) {
              //         this.$emit("save-success");
              //         this.$message.success("替换成功");
              //         this.dialogVisible = false;
              //       }
              //       this.submitLoading = false;
              //     })
              //     .catch(() => {
              //       this.submitLoading = false;
              //     });
            }
          }
        });
      },
    },
  };
</script>
<style scoped>
.el-input-group__append button.el-button {
  background-color: skyblue;
  color: white;
}
</style>